import React, { useState, useEffect, useCallback } from "react";
import { FaPen, FaTrash, FaTimes } from "react-icons/fa";
import "./DepartmentList.css";
import Header from "../../layouts/Employee/Header";
import SubHeader from "../../layouts/Admin/SubHeader";
import DepartmentListLayout from "../../layouts/Admin/DepartmentListLayout";

const DepartmentList = () => {
  return (
    <>
      <Header />
      <SubHeader />
      <DepartmentListLayout />
    </>
  );
};

export default DepartmentList;
